"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEST_SECONDARY_CONFIGURATION_STORAGE = exports.TEST_CONFIGURATION_STORAGE_CDN_BACKUP = exports.TEST_CONFIGURATION_STORAGE_CDN = exports.TEST_CONFIGURATION_STORAGE = exports.SECONDARY_CONFIGURATION_STORAGE = exports.CONFIGURATION_STORAGE_CDN_BACKUP = exports.CONFIGURATION_STORAGE_CDN = exports.CONFIGURATION_STORAGE = exports.CHINA_TEST_SECONDARY_CONFIGURATION_STORAGE = exports.CHINA_TEST_CONFIGURATION_STORAGE_CDN = exports.CHINA_TEST_CONFIGURATION_STORAGE = exports.CHINA_SECONDARY_CONFIGURATION_STORAGE = exports.CHINA_CONFIGURATION_STORAGE_CDN = exports.CHINA_CONFIGURATION_STORAGE = void 0;
exports.getStorageUrls = getStorageUrls;
const CONFIGURATION_STORAGE_CDN = exports.CONFIGURATION_STORAGE_CDN = 'https://configurationmanager.oriflame.com';
const CONFIGURATION_STORAGE_CDN_BACKUP = exports.CONFIGURATION_STORAGE_CDN_BACKUP = 'https://oriconfigmanagerlive.azureedge.net';
const CONFIGURATION_STORAGE = exports.CONFIGURATION_STORAGE = 'https://oriconfigmanagerlive.blob.core.windows.net';
const SECONDARY_CONFIGURATION_STORAGE = exports.SECONDARY_CONFIGURATION_STORAGE = 'https://oriconfigmanagerlive-secondary.blob.core.windows.net';
const TEST_CONFIGURATION_STORAGE_CDN = exports.TEST_CONFIGURATION_STORAGE_CDN = 'https://configurationmanager-test.oriflame.com';
const TEST_CONFIGURATION_STORAGE_CDN_BACKUP = exports.TEST_CONFIGURATION_STORAGE_CDN_BACKUP = 'https://oriconfigurationmanager.azureedge.net';
const TEST_CONFIGURATION_STORAGE = exports.TEST_CONFIGURATION_STORAGE = 'https://oriconfigurationmanager.blob.core.windows.net';
const TEST_SECONDARY_CONFIGURATION_STORAGE = exports.TEST_SECONDARY_CONFIGURATION_STORAGE = 'https://oriconfigurationmanager-secondary.blob.core.windows.net';

// China - CE2 region URIs
const CHINA_CONFIGURATION_STORAGE_CDN = exports.CHINA_CONFIGURATION_STORAGE_CDN = 'https://oriconfigmanagerlive.oriflame.cn';
const CHINA_CONFIGURATION_STORAGE = exports.CHINA_CONFIGURATION_STORAGE = 'https://oriconfigmanagerlive.blob.core.chinacloudapi.cn';
const CHINA_SECONDARY_CONFIGURATION_STORAGE = exports.CHINA_SECONDARY_CONFIGURATION_STORAGE = 'https://oriconfigmanagerlive-secondary.blob.core.chinacloudapi.cn';
const CHINA_TEST_CONFIGURATION_STORAGE_CDN = exports.CHINA_TEST_CONFIGURATION_STORAGE_CDN = 'https://oriconfigurationmanager.oriflame.cn';
const CHINA_TEST_CONFIGURATION_STORAGE = exports.CHINA_TEST_CONFIGURATION_STORAGE = 'https://oriconfigurationmanager.blob.core.chinacloudapi.cn';
const CHINA_TEST_SECONDARY_CONFIGURATION_STORAGE = exports.CHINA_TEST_SECONDARY_CONFIGURATION_STORAGE = 'https://oriconfigurationmanager-secondary.blob.core.chinacloudapi.cn';
function getStorageUrls(environment, region) {
  const isLiveEnvironment = environment === 'live';
  const isChinaRegion = region.toLowerCase() === 'ce2';
  const storageUrlProvider = {
    settingsStorageCdn: getSettingsStorageCdnUrl(isLiveEnvironment, isChinaRegion),
    settingsStorage: getSettingsStorageUrl(isLiveEnvironment, isChinaRegion),
    settingsSecondaryStorage: getSecondaryStorageUrl(isLiveEnvironment, isChinaRegion)
  };
  return storageUrlProvider;
}
function getSettingsStorageCdnUrl(isLiveEnvironment, isChinaRegion) {
  if (isChinaRegion) {
    return isLiveEnvironment ? CHINA_CONFIGURATION_STORAGE_CDN : CHINA_TEST_CONFIGURATION_STORAGE_CDN;
  }
  return isLiveEnvironment ? CONFIGURATION_STORAGE_CDN : TEST_CONFIGURATION_STORAGE_CDN;
}
function getSettingsStorageUrl(isLiveEnvironment, isChinaRegion) {
  if (isChinaRegion) {
    return isLiveEnvironment ? CHINA_CONFIGURATION_STORAGE : CHINA_TEST_CONFIGURATION_STORAGE;
  }
  return isLiveEnvironment ? CONFIGURATION_STORAGE : TEST_CONFIGURATION_STORAGE;
}
function getSecondaryStorageUrl(isLiveEnvironment, isChinaRegion) {
  if (isChinaRegion) {
    return isLiveEnvironment ? CHINA_SECONDARY_CONFIGURATION_STORAGE : CHINA_TEST_SECONDARY_CONFIGURATION_STORAGE;
  }
  return isLiveEnvironment ? SECONDARY_CONFIGURATION_STORAGE : TEST_SECONDARY_CONFIGURATION_STORAGE;
}
